// extracted by mini-css-extract-plugin
export default {"systemIcon":"SystemIcon_systemIcon__ZT9Dw"};